<template>
  <div class="d-flex justify-center align-center fill-height ps-2">
    <base-card>
      <vee-form v-slot="{ errors }" class="d-contents" novalidate @submit="handleSubmit()">
        <header class="d-flex flex-column mb-1">
          <div class="d-flex justify-center">
            <img src="@/assets/logo-c-desk-login.svg" alt="Logo" loading="lazy" />
          </div>

          <h2 class="text-center">Conecte-se ao seu espaço</h2>
          <span>Utilize um dos métodos de autenticação abaixo.</span>
        </header>

        <div class="d-flex flex-column fill-width mb-2" style="gap: 8px;">
          <input-details
            v-model="form.login"
            name="login"
            label="Login / Email"
            prepend-icon="mdi:account"
            placeholder="Login / Email" rules="required"
          />

          <input-details
            v-model="form.password"
            name="password"
            label="Senha"
            placeholder="Senha"
            prepend-icon-class="cursor-pointer"
            rules="required"
            :prepend-icon="`mdi:lock${showPassword.type === 'text' ? '-off' : ''}`"
            :type="showPassword.type"
            @click:prepend-icon="() => {
              showPassword = {
                type: showPassword.type === 'text' ? 'password' : 'text',
              }
            }"
          />
        </div>

        <div class="d-flex flex-row align-center fill-width justify-space-between mb-2">
          <!-- <input-check v-model="form.rememberMe" label="Lembrar de mim" /> -->
           <div></div>
          <span>
            <nuxt-link
            :to="useUseRouteCallbackUrl('/forgot-password')"
            class="mt-2">Esqueceu a senha?</nuxt-link>
          </span>
        </div>

        <div class="button-action mb-2">
          <base-button
            text="Entrar"
            type="submit"
            :disabled="Object.keys(errors).length > 0"
            :loading="isLoading"
            class="btn-fill"
          />
        </div>

        <!-- <div class="d-flex align-center flex-row fill-width mb-2">
            <div class="divider" />
            <span class="ps-6">ou</span>
            <div class="divider" />
          </div> -->

        <div class="no-account mb-2">
          <div class="divider" />
          <div class="d-flex align-center fill-width flex-column pa-4">
            <span>Não possui uma conta?</span>
            <nuxt-link
              :to="useUseRouteCallbackUrl('/signup')"
              class="mt-2"
            >
              Cadastre-se
            </nuxt-link>
          </div>
          <div class="divider" />
        </div>

        <footer>
          <img src="@/assets/logo-vertical.svg" alt="logo" />
        </footer>
      </vee-form>
    </base-card>
  </div>
</template>

<script setup lang="ts">
import type { LoginResponse } from '../../server/api/auth/login'
import type { FetchError } from 'ofetch';

definePageMeta({
  layout: 'auth',
  middleware: ['unauthenticated-only']
})

const isLoading = ref(false)

const form = ref<Partial<{
  login: string,
  password: string,
  rememberMe: boolean
}>>({
  login: '',
  password: '',
  rememberMe: false
})

const { fetch } = useUserSession()
const route = useRoute()

const errorId = ref<string | null>(null)

const showPassword = ref<{ type: 'text' | 'password' }>({ type: 'password' })

const handleSignIn = async () => {
  try {
    await useFetchApi<LoginResponse>('/api/auth/login', {
      method: 'POST',
      body: {
        login: form.value.login,
        password: form.value.password,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });

    await fetch()
  } catch (error) {
    const fechError = error as FetchError;

    errorId.value = (fechError.data?.id || fechError.data?.data?.id) ?? null;

    return error;
  }
}

const handleSubmit = async () => {
  try {
    isLoading.value = true

    await handleSignIn()

    const callbackUrl = (route.query.callbackUrl || '/home') as string
    const redirectUrl = callbackUrl.replace(useRuntimeConfig().public.baseUrl, '')

    if (errorId.value ===  'USER_NOT_ACTIVATED') {
      return await navigateTo({
        path: '/confirm-account',
        query: {
          email: form.value.login,
          callbackUrl
        }
      })
    }

    try {
      await navigateTo(redirectUrl)
    } catch (error: unknown) {

      const store = errorStore();
      store.ADD_ERROR({ id: 'NO_REDIRECT_EXTERNAL_URL' });
      await navigateTo('/home')

      return error;
    }
  } catch(error: unknown) {
    return error;
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped>
.button-action {
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 40px;
}

.no-account {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  a,
  span {
    width: fit-content;
  }
}
</style>
